// Este componente es el que se encarga de mostrar la lista de cursos en la base de datos del cliente.
import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map } from "lodash";
import { ClientDBcreatorItems } from "../ClientDBcreatorItems";
import { ClientDB_API } from "../../../../api";
//import { useAuth } from "../../../../hooks";
import "./ClientDBcreatorList.scss";

const clientController = new ClientDB_API();

export function ClientDBcreatorList(props) {
  //const { user } = useAuth();
  const { reload, onReload } = props;
  const [clients, setClients] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const response = await clientController.getClients({ page, limit: 3 }); //le envio un objeto con page y limit
        // console.log(response);
        setClients(response.clients.docs); //esto es para que se muestren los cursos
        console.log("reload", reload);

        setPagination({
          limit: response.clients.limit,
          page: response.clients.page,
          total: response.clients.totalPages,
          totalDocs: response.clients.totalDocs,
        });
      } catch (error) {
        throw error;
      }
    })();
  }, [page, reload]); //se vuelve a ejecutarcada vez que cambie la pagina

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!clients) return <Loader active inline="centered" />; //esot hace que se muestre el loader mientras se carga la data
  if (size(clients) === 0) return <h2>No hay clientes</h2>; //esto hace que si no hay cursos muestre el mensaje
  //en caso de que si haya cursos
  //

  return (
    <div className="list-clients">
      {map(clients, (client) => (
        <ClientDBcreatorItems
          key={client._id}
          client={client}
          onReload={onReload}
        />
      ))}

      <div className="list-clients__pagination">
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
